import React from 'react';
import Home from 'landing';

export default function LandingPage() {
  return <Home />;
}
